export class Patrimonio {

    constructor(config = {}) {
        this.model = {
            id: {
                value: null,
                table: false,
            },
            anio_declaracion_renta: {
                value: null,
                header: 'AÑO ÚLTIMA DECLARACIÓN DEL IMPUESTO A LA RENTA:',
                required: 'Año de declaración de renta es requerido',
                min: 3,
                max: 20,
                minLength: 'Mínimo 3 caracteres',
                maxLength: 'Máximo 20 caracteres permitidos'
            },
        }
    }

    optionLabel = 'nombre';
}
